import { format } from "date-fns";

const SHORT_DATE_FNS_FORMAT = "dd-MMM-yyyy HH:mm"; // 21-Sep-2026 12:06
const LONG_DATE_FNS_FORMAT = "dd-MMMM-yyyy HH:mm:ss"; // 21-September-2026 12:06:34

export const formatterShort = (value: string) => {
  return format(value, SHORT_DATE_FNS_FORMAT);
};

// NOT used, because not required, but MIGHT be needed after Business change their mind
export const formatterLong = (value: string) => {
  return format(value, LONG_DATE_FNS_FORMAT);
};

// Value "en" is used as part of JSON file with translations strings
// As result it defines if useTranslation() returns proper data
// If decision will be to change to `en-US`, then need to change also file name and code inside of i18n.ts
export const PREFERRED_LANGUAGE = "en";

// !!! NOT used !!!
export const formatterES5 = (
  value: string,
  customOptions?: Intl.DateTimeFormatOptions
) => {
  // ES5
  const defaultOptions: Intl.DateTimeFormatOptions = {
    day: "2-digit", // → "01"
    month: "short", // → "Sep"
    year: "numeric", // → "2026"
    hour: "2-digit", // → "13"
    minute: "2-digit", // → "15"
    hourCycle: "h23" // 24h format, range 00–23 (avoids "24:00" bug)
  };

  const formatter = new Intl.DateTimeFormat("en", {
    ...defaultOptions,
    ...customOptions
  });

  const p = Object.fromEntries(
    formatter
      .formatToParts(new Date(value))
      .map(({ type, value }): [Intl.DateTimeFormatPartTypes, string] => [
        type,
        value
      ])
  );

  return `${p.day}-${p.month}-${p.year} ${p.hour}:${p.minute}`;
};

// !!! NOT used !!!
export const formatterES2021 = (
  value: string,
  customOptions?: Intl.DateTimeFormatOptions
) => {
  // ES2021
  const defaultOptions: Intl.DateTimeFormatOptions = {
    dateStyle: "medium", // ES2020, ES2021
    timeStyle: "short", // ES2020, ES2021
    hourCycle: "h23" // since ES2020
  };

  const formatter = new Intl.DateTimeFormat("en-GB", {
    ...defaultOptions,
    ...customOptions
  });

  return formatter.format(new Date(value));
};
